import { Button, ButtonProps } from '@mui/material';
import PencilIcon from 'asset/icons/Pencil';
import { memo } from 'react';

interface Props extends ButtonProps {}

const ButtonEdit = memo(({ ...rest }: Props) => {
  return (
    <Button
      sx={{
        minWidth: '38px !important',
        height: '32px',
        '&.MuiButton-root': {
          padding: '0px !important',
        },
      }}
      variant="contained"
      color="secondary"
      {...rest}
    >
      <PencilIcon fill="white" />
    </Button>
  );
});

export default ButtonEdit;
